import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Stats from "@/components/Stats";
import RoiCalculator from "@/components/RoiCalculator";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Areas from "@/components/Areas";
import Sustainability from "@/components/Sustainability";
import Director from "@/components/Director";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  const [lostCarts, setLostCarts] = useState(1);
  const [cartPrice, setCartPrice] = useState(1200);

  useEffect(() => {
    document.title = "ResgateCar — Monitoramento, Rastreamento e Resgate de Carrinhos";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-[#1E3A8A] text-slate-50 noise">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <Services />
        <RoiCalculator lostCarts={lostCarts} onLostCartsChange={setLostCarts} price={cartPrice} onPriceChange={setCartPrice} />
        <Manifesto />
        <Areas />
        <Sustainability />
        <Director />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
